import { Component as StateComponent } from 'client/app/apps/disco-prototype/state/liquidSet';
import { convertValue } from 'client/app/apps/disco-prototype/state/request/convertValue';
import { Component } from 'common/types/disco/liquidSet';

export const convertComponent = (c: StateComponent): Component => ({
  id: c.id,
  name: convertValue(c.name),
  concentration: convertValue(c.concentration),
});
